module.exports = __webpack_public_path__ + "static/media/dropImage1.36841c02.PNG";